// src/api/userService.js
import axios from 'axios';
import { api } from "./api";




const token = '';



export const getDeviceLatLong = async () => {
  if (!navigator.geolocation) {
    return { error: 'Geolocation is not supported by your browser' };
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          lat: position.coords.latitude,
          long: position.coords.longitude,
        });
      },
      (err) => {
        reject({ error: 'Error getting location: ' + err.message });
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
};


export const loginUser = async (data) => {
  if (data.mobile && data.mobile.length != 10) {
    return { data: { status: false, message: 'Mobile Number Invalid.' } };
  }
  // console.log(data);
  return await api.post('/client/login', data);

};


export const get_data = async (data) => {
  return await api.get('/import/map/data?name=Import', data);
};

export const profiledetails = async (data) => {
  const userId = localStorage.getItem("id");
  return await api.get(`/client/profile/details/${userId}`);
  // yahe per be login kerna per jo id melage os ko kaem me lane ha 
};
export const profileupdate = async (data) => {
  return await api.post('/client/profile/update', data)
  // yahe per be login kerna per jo id melage os ko kaem me lane ha 
};

export const getBusinessDetails = async (data=null) => {
  return await api.get('/settings')
};

export const updataRTE = async (data) => {
  return await api.post('/settings/rte/post', data);
};


export const businessdetail = async (data) => {
  return await api.post('/settings/business/detail/post', data);
};

export const gststatus = async (data) => {
  return await api.post('/update/gst/status', data);
};


export const schooldetails = async (data) => {
  return await api.post('/settings/school/detail/post', data);
};

export const socialdetails = async (data) => {
  return await api.post('/settings/social/media/post', data);
};





export const updateProfilePost = async (data) => {
  // console.log(data.name);
  // return JSON.stringify(data);
  if (data.mobile && data.mobile.length != 10) {
    return { data: { status: false, message: 'Mobile Number Invalid.' } };
  }

  return await api.post('settings/business/post', data)

};
export const createRole = async (payload) => {
  return await api.post('roles/create', payload)

};
export const userRoll = async () => {
  return await api.get('roles/view')

};
export const getRoleById = async (id) => {
  return await api.get(`roles/update/${id}`);
};
export const updateRole = async (id, data) => {
  return await api.post(`roles/update/post?id=${id}`, data);
};


export const getRole = async (data) => {
  return await api.get('users_create', data)

};
export const createusers = async (data) => {
  return await api.post('/PostCreateUser', data)

};
export const UsersView = async () => {
  return await api.get('users')

};
export const UsersEdit = async (id) => {
  // console.log(id)
  return await api.get(`UserEdit/${id}`)
};
export const editusers = async (data) => {
  return await api.post("PostUserEdit", data)
};
export const userDelete = async (id) => {
  return await api.get(`UserDelete/${id}`,)
};

export const updateProfileImg = async (formData) => {
  return await api.post('settings/logo/update/post', formData);

};
export const passwordupdata = async (data) => {
  return await api.post('client/password/reset', data);

};

export const WhatsappDetails = async (data) =>{
  return await api.post(`/settings/update/message/mode`, data)
}


//user role create

export const AssignUserRole = async (payload)=>{
  return await api.post(`/roles/create`,payload);
}

